/*
  Документы счёта на вкладке «Суд»: страницы режет сервер (21.10.2026, требование
  владельца: «пагинация должна быть серверной, а не на фронте»).

  Прежде список документов приходил внутри карточки счёта целиком, вместе с текстом каждого
  документа в базе, и карточка резала его в браузере. Теперь карточка несёт только число
  (`documents_total`, для значка вкладки), а страницы документов читаются отдельной точкой
  `GET /accounts/{id}/documents` - и только когда вкладка открыта.

  Карточка перечитывается после каждого действия (собрали пакет, удалили документ, сменили
  стадию): `version` - сама карточка, и когда она сменилась, страница перечитывается тем же
  окном. Так собранный только что пакет виден сразу, а не после перезагрузки.
*/

import { useCallback, useEffect, useRef } from 'react'

import { api } from '../api/client.js'
import { Loading, Notice } from './Common.jsx'
import DocumentList from './DocumentList.jsx'
import usePagedList from './usePagedList.js'

export default function AccountDocuments({ accountId, version, onDeleted, empty }) {
  const load = useCallback((window) => api.accountDocuments(accountId, window), [accountId])
  const { rows, error, reload, bar } = usePagedList(load)

  // Первое чтение делает сам хук; перечитывать нужно, только когда карточка СМЕНИЛАСЬ.
  const seen = useRef(version)
  useEffect(() => {
    if (seen.current === version) return
    seen.current = version
    reload()
  }, [version, reload])

  if (error) {
    return (
      <section className="section">
        <h2 className="section__title">Документы</h2>
        <Notice error={error} />
      </section>
    )
  }
  if (rows === null) return <Loading what="Загружаем документы" />

  return <DocumentList documents={rows} paging={bar} onDeleted={onDeleted} empty={empty} />
}
